import React, {useState} from "react";
import SectionView from "../../../Common/Views/SectionView";
import SemesterListItem from "../../../Common/Views/ListItems/SemesterListItem";
import Course from "../../../Common/Models/Course";
import useCourses from "../../../Common/Context/Consumers/useCourses";
import Semester from "../../../Common/Models/Semester";
import ViewMoreSemestersButton from "./ViewMoreSemestersButton";

interface CourseListViewProps {
    onClick: (course: Course) => void;
}

const CourseListView = (props: CourseListViewProps) => {
    const {onClick} = props;
    const [open, setOpen] = useState(false);
    const semesters: any = useCourses();
    const displaySemesters = (semesters: Semester[]) =>
        semesters.map((semester,index) => <SemesterListItem
            key={index + 1}
            semester={semester}
            isCurrent={semester.isCurrent}
            onClick={onClick}
        />);

        const viewMoreSemesters = () => setOpen(!open);

    return (
        <>
            {semesters && semesters[0] &&
                <SectionView disableGutters title={"Courses"}>

                    <SemesterListItem
                        key={0}
                        semester={semesters[0]}
                        isCurrent={semesters[0].isCurrent}
                        onClick={onClick}
                    />
                    {open && displaySemesters(semesters.slice(1))}
                    <ViewMoreSemestersButton onClick={viewMoreSemesters} open={open} />
                </SectionView>
            }
        </>
    );
};

export default CourseListView;